const LogSystemTypeEnum = {
  1: 'Login realizados',
}

export default LogSystemTypeEnum;
